import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { Button } from "../Button";

import styles from "./Tile.scss";

const TileButton = forwardRef(({ children, isCTA, ...otherProps }, ref) => {
  return (
    <div className={styles.button_wrapper} ref={ref}>
      <Button
        {...otherProps}
        variants={cx(Button.Variant.full, { [Button.Variant.outline]: !isCTA })}
      >
        {children}
      </Button>
    </div>
  );
});

TileButton.propTypes = {
  isCTA: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

TileButton.defaultProps = {
  isCTA: false,
};

TileButton.displayName = "Tile.Button";

export default TileButton;
